import React from "react";
import {FormModalProps} from "../../utils/useFormModal";
import {Form, Input, InputNumber, Modal} from "antd";
import Select from "../../components/Select";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props;

    return (
        <Modal {...otherProps}>
            <Form form={form} layout="vertical">
                <Form.Item name={'from'} label={'From'} rules={[{required: true, message: 'Please input From'}]}>
                    <Select url={'/dict/?typeId=currency'} valueField={'value'} textField={'name'}
                            getData={data => data.data}
                            allowClear/>
                </Form.Item>
                <Form.Item name={'to'} label={'To'} rules={[{required: true, message: 'Please input To'}]}>
                    <Select url={'/dict/?typeId=currency'} valueField={'value'} textField={'name'}
                            getData={data => data.data}
                            allowClear/>
                </Form.Item>
                <Form.Item name={'rate'} label={'Value'} rules={[{required: true, message: 'Please input Value'}]}>
                    <InputNumber precision={8} style={{width: '100%'}}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
